import axios from 'axios';
import { getToken } from '../helpers';
let notificationAdapter = {
    error: (message, title) => {
        const prefix = title ? `[${title}] ` : '';
        console.error(`${prefix}${message}`);
    },
};
export const setNotificationAdapter = (adapter = {}) => {
    notificationAdapter = {
        ...notificationAdapter,
        ...adapter,
    };
};
const notifyError = (message, title) => {
    try {
        if (notificationAdapter && typeof notificationAdapter.error === 'function') {
            notificationAdapter.error(message, title);
            return;
        }
    }
    catch (error) {
        console.error('Notification adapter error:', error);
    }
    const prefix = title ? `[${title}] ` : '';
    console.error(`${prefix}${message}`);
};
export const apiUrl = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
export const defaultParams = () => ({
    headers: { Authorization: `Bearer ${getToken()}` },
});
// Request Interceptor - adiciona token do Cognito
axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));
// Response Interceptor - redireciona em caso de 401
axios.interceptors.response.use((response) => response, (error) => {
    // Handle 401 Unauthorized - redireciona para login
    if (error.response?.status === 401) {
        console.warn('Erro 401: NÇœo autorizado, redirecionando para login');
        // Redireciona para login - Cognito gerencia re-autenticaÇõÇœo
        if (typeof window !== 'undefined') {
            if (window.location.pathname !== '/log_in') {
                window.location.href = '/log_in';
            }
        }
        // Evita rejeiÇõÇœes nÇœo tratadas (logout/tela de login)
        return Promise.resolve(error.response || error);
    }
    // Notifica outros erros via adapter
    else if (error.response?.data) {
        const headers = error.config?.headers;
        const skipNotification = Boolean(error.config?.skipNotification
            || headers?.['x-skip-notification']
            || headers?.['X-Skip-Notification']
            || headers?.get?.('x-skip-notification')
            || headers?.get?.('X-Skip-Notification'));
        if (skipNotification) {
            return Promise.reject(error);
        }
        const err = error.response.data;
        const msg = err.error || err.message || 'Erro inesperado';
        notifyError(msg, 'Erro');
    }
    else if (error.message) {
        notifyError(error.message, 'Erro');
    }
    return Promise.reject(error);
});
export default axios;
